import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import housingReducer from './slices/housingSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    
    housingData: housingReducer,
  },
});

export default store;
